import { all, put, fork, takeEvery, delay, select } from 'redux-saga/effects';
import { get, post, PUT, postWithToken } from '@iso/lib/helpers/resApiRequestor';
import actions from './actions';
import _ from 'lodash';
import { injectRequestorInformation } from '@iso/lib/helpers/utility';

export function* getSampleList() {
  yield takeEvery('FETCH_SAMPLE', function* () {
    try {
      yield put({
        type: actions.FETCHING_SAMPLE,
      });
      // const apiResult = yield sampleGetCall();
      // const result = apiResult.data;
      // if (result.success) {
      const sampleData = [
        {
          id: '1',
          name: 'Option 1'
        },
        {
          id: '2',
          name: 'Option 2'
        },
        {
          id: '3',
          name: 'Option 3'
        }
      ];
      yield delay(3000);
      yield put({
        type: actions.FETCHED_SAMPLE,
        data: sampleData,
      });
      // }
    } catch (error) {
      yield put({
        type: actions.FETCH_SAMPLE_FAILED,
        message: error,
      });
    }
  });
}

export function* searchAuditLogs() {
  yield takeEvery('SEARCH_AUDITLOGS', function* (payload) {
    // // console.log('ENTER_SAGA 1', payload.payload);
    try {
      if (payload.payload.resetList === true) {
        yield put({
          type: actions.RESET_AUDITLOGS,
        });
      }
      yield put({
        type: actions.SEARCHING_AUDITLOGS,
      });
      const state = yield select();
      let searchResultCollection = state.Settings.searchResultCollection;
      if (searchResultCollection && searchResultCollection.hasOwnProperty(payload.payload.currentPage)) {
        console.log('CHECK PAGE EXISTING', searchResultCollection);
        yield put({
          type: actions.SEARCHED_AUDITLOGS,
          result: searchResultCollection[payload.payload.currentPage],
          page: payload.payload.currentPage,
          collection: searchResultCollection,
          filterParams: payload.payload.currentPage
        });
      } else {
        const apiResult = yield searchAudit(payload.payload);
        console.log('CHECK API RESULT LOGS');
        const result = apiResult.data;
        console.log('CHECK API RESULT DATA', result);
        if (result.success === true) {
          searchResultCollection = {
            ...searchResultCollection,
            [payload.payload.currentPage]: result.data
          };
          yield put({
            type: actions.SEARCHED_AUDITLOGS,
            result: result.data,
            page: payload.payload.currentPage,
            collection: searchResultCollection,
            filterParams: payload.payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SEARCH_AUDITLOGS_FAILED,
      });
    }
  });
}

export function* downloadAuditLogs() {
  yield takeEvery('DOWNLOAD_AUDIT_LOGS', function* (payload) {
    try {
      yield put({
        type: actions.DOWNLOADING_AUDIT_LOGS,
      });
      const state = yield select();
      const apiResult = yield downloadAuditLogsRequest(payload.payload);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DOWNLOADED_AUDIT_LOGS,
          payload: result.data,
        });
        const currentData = state.Settings.logsDownloadList;
        const newList = _.union([result.data], currentData);
        yield put({
          type: actions.FETCHED_LOGS_DOWNLOAD_LIST,
          payload: newList,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_FAILED_AUDIT_LOGS,
        payload: error,
      });
    }
  });
}

export function* getLogsDownloadList() {
  yield takeEvery('FETCH_LOGS_DOWNLOAD_LIST', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_LOGS_DOWNLOAD_LIST,
      });

      const apiResult = yield fetchDownloadListApi(payload.payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCHED_LOGS_DOWNLOAD_LIST,
          payload: result.data,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOGS_DOWNLOAD_LIST_FAILED,
        payload: error,
      });
    }
  });
}

// FETCH DOWNLOAD LOGS REPORT
export function* fetchDownloadReport() {
  yield takeEvery('FETCH_DOWNLOAD_LOGS_REPORT', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_DOWNLOAD_LOGS_REPORT,
      });
      const apiResult = yield getDownloadReportApi(payload.payload);
      console.log('FETCH TRX REPORT', apiResult);
      if (apiResult.data.success) {
        const result = apiResult.data;
        yield put({
          type: actions.FETCHED_DOWNLOAD_LOGS_REPORT,
          data: result ? result.base64 : null,
        });
      } else {
        yield put({
          type: actions.FETCH_DOWNLOAD_LOGS_REPORT_FAILED,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_DOWNLOAD_LOGS_REPORT_FAILED,
      });
    }
  });
}

export function* fetchLookups() {
  yield takeEvery('FETCH_LOOKUPS', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_LOOKUPS,
      });
      console.log('CHECK FETCH_LOOKUPS PAYLOAD', payload.payload);
      const apiResult = yield fetchLookupsReq(payload.payload);
      const result = apiResult.data;
      console.log('CHECK FETCH_LOOKUPS RESULT DATA', apiResult.data);
      if (result.success) {
        yield put({
          type: actions.FETCHED_LOOKUPS,
          result: result.data
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOOKUPS_FAILED,
      });
    }
  });
}

export function* fetchUserManagementLookups() {
  yield takeEvery(actions.FETCH_USER_MANAGEMENT_LOOKUPS, function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_USER_MANAGEMENT_LOOKUPS,
      });
      console.log('CHECK FETCH_USER_MANAGEMENT_LOOKUPS PAYLOAD', payload.payload);

      const apiResult = yield fetchUserManagementLookupsReq(payload.payload);
      const result = apiResult.data;

      console.log('CHECK FETCH_USER_MANAGEMENT_LOOKUPS RESULT DATA', apiResult.data);

      if (result.success) {
        yield put({
          type: actions.FETCHED_USER_MANAGEMENT_LOOKUPS,
          result: result.data
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USER_MANAGEMENT_LOOKUPS_FAILED,
      });
    }
  });
}

export function* fetchResponseCodeLookups() {
  yield takeEvery(actions.FETCH_RESPONSE_CODE_LOOKUPS, function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_RESPONSE_CODE_LOOKUPS,
      });
      console.log('CHECK FETCH_RESPONSE_CODE_LOOKUPS PAYLOAD', payload.payload);

      const apiResult = yield fetchResponseCodeLookupsReq(payload.payload);
      const result = apiResult.data;

      console.log('CHECK FETCH_RESPONSE_CODE_LOOKUPS RESULT DATA', apiResult.data);

      if (result.success) {
        yield put({
          type: actions.FETCHED_RESPONSE_CODE_LOOKUPS,
          result: result.data
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RESPONSE_CODE_LOOKUPS_FAILED,
      });
    }
  });
}

export function* fetchLookupsStatus() {
  yield takeEvery('FETCH_LOOKUPS_STATUS', function* (payload) {
    yield put({
      type: actions.FETCHING_LOOKUPS_STATUS,
    });
    try {
      const apiResult = yield fetchStatusLookupsData(payload.payload);
      const result = apiResult.data;
      console.log('FETCH_LOOKUPS_STATUS-RESULT: ', result);
      if (result.success === true) {
        yield put({
          type: actions.FETCHED_LOOKUPS_STATUS,
          payload: result.data.result,
          // result: result.success,
        });
      } else {
        yield put({
          type: actions.FETCH_LOOKUPS_STATUS_FAILED,
          payload: result.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOOKUPS_STATUS_FAILED,
        payload: error,
      });
    }
  });
}

export function* addLookups() {
  yield takeEvery('ADD_LOOKUPS', function* (payload) {
    try {
      yield put({
        type: actions.ADDING_LOOKUPS,
      });
      console.log('ADD LOOKUPS PAYLOAD', payload.payload);
      const apiResult = yield addLookupsReq(payload.payload);
      const result = apiResult.data;
      console.log('ADD LOOKUPS RESULT', result);
      if (result.success) {
        yield put({
          type: actions.ADDED_LOOKUPS,
          result: result.data,
        });
      } else {
        yield put({
          type: actions.ADD_LOOKUPS_FAILED,
          payload: result.message ? result.message : 'Lookup label already exists.',
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LOOKUPS_ERROR,
        payload: error
      });
    }
  });
}

export function* updateLookups() {
  yield takeEvery('UPDATE_LOOKUPS', function* (payload) {
    try {
      yield put({
        type: actions.UPDATING_LOOKUPS,
      });
      const apiResult = yield updateLookupsReq(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATED_LOOKUPS,
          result: result.data,
        });
      } else {
        yield put({
          type: actions.UPDATE_LOOKUPS_FAILED,
          payload: result.message ? result.message : 'Lookup label already exists.',
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_LOOKUPS_ERROR,
      });
    }
  });
}

export function* fetchResponseCode() {
  yield takeEvery('FETCH_RESPONSE_CODE', function* (payload) {
    try {
      const loadmore = payload.payload.loadmore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_RESPONSE_CODE,
        });
      } else {
        yield put({
          type: actions.FETCHING_RESPONSE_CODE,
        });
      }
      const apiResult = yield fetchResponseCodeReq(payload.payload);
      const result = apiResult.data;
      const currentList = payload.payload.currentReponseCodeList;
      const finalData = currentList ? currentList.concat(result.data.result) : result.data.result;
      if (result.success) {
        yield put({
          type: actions.FETCHED_RESPONSE_CODE,
          result: finalData,
          pagination: result.data.pagination
        });
      } else {
        yield put({
          type: actions.FETCH_RESPONSE_CODE_FAILED,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RESPONSE_CODE_ERROR,
      });
    }
  });
}

export function* addResponseCode() {
  yield takeEvery('ADD_RESPONSE_CODE', function* (payload) {
    try {
      yield put({
        type: actions.ADDING_RESPONSE_CODE,
      });
      const apiResult = yield addResponseCodeReq(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADDED_RESPONSE_CODE,
          result: result.data.result,
          pagination: result.data.pagination
        });
      } else {
        yield put({
          type: actions.ADD_RESPONSE_CODE_FAILED,
          payload: result.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_RESPONSE_CODE_ERROR,
      });
    }
  });
}

export function* updateResponseCode() {
  yield takeEvery('UPDATE_RESPONSE_CODE', function* (payload) {
    try {
      yield put({
        type: actions.UPDATING_RESPONSE_CODE,
      });
      const apiResult = yield updateResponseCodeReq(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATED_RESPONSE_CODE,
          result: result.data.result,
          pagination: result.data.pagination
        });
      } else {
        yield put({
          type: actions.UPDATE_RESPONSE_CODE_FAILED,
          payload: result.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_RESPONSE_CODE_ERROR,
      });
    }
  });
}

export function* deleteResponseCode() {
  yield takeEvery('DELETE_RESPONSE_CODE', function* (payload) {
    try {
      yield put({
        type: actions.DELETING_RESPONSE_CODE,
      });
      const apiResult = yield deleteResponseCodeReq(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETED_RESPONSE_CODE,
          result: result.data.result,
        });
      } else {
        yield put({
          type: actions.DELETE_RESPONSE_CODE_FAILED,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_RESPONSE_CODE_ERROR,
      });
    }
  });
}

export function* getRolesList() {
  yield takeEvery('FETCH_ROLE', function* () {
    try {
      yield put({
        type: actions.FETCHING_ROLE,
      });
      const apiResult = yield getRoles();
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCHED_ROLE,
          data: result.data,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ROLE_FAILED,
        message: error,
      });
    }
  });
}

export function* addAuthRole() {
  yield takeEvery('ADD_AUTH_ROLES', function* (payload) {
    try {
      yield put({
        type: actions.ADDING_AUTH_ROLES,
      });
      const apiResult = yield addAuthRoleReq(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        const apiResultRole = yield getRoles();
        const resultRole = apiResultRole.data;
        yield put({
          type: actions.AUTH_ROLES_ADDED,
          payload: resultRole.data,
        });
      } else {
        yield put({
          type: actions.ADD_AUTH_ROLES_FAILED,
          payload: result.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_AUTH_ROLES_FAILED,
        payload: 'Failed to add role',
      });
    }
  });
}

export function* fetchPermission() {
  yield takeEvery('FETCH_PERMISSION', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_PERMISSION,
      });
      console.log('CHECK PAYLOAD', payload);
      const apiResult = yield fetchRolePermissionRequest(payload.payload);
      const result = apiResult.data;
      console.log('FETCH_PERMISSION-RESULT: ', result);
      const apiResultCore = yield fetchCoreModuleRequest(payload.payload);
      const resultCore = apiResultCore.data;
      console.log('FETCH_CORE-RESULT: ', resultCore);
      if (result.success === true) {
        yield put({
          type: actions.ROLE_PERMISSION_FETCHED,
          payload: result.data,
          payloadCore: resultCore.data,
          selectedId: payload.payload,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PERMISSION_FAILED,
        payload: error,
      });
    }
  });
}

export function* fetchStatus() {
  yield takeEvery('FETCH_STATUS', function* () {
    // console.log()
    try {
      const apiResult = yield fetchStatusRequest();
      console.log('FETCH_STATUS-RESULT: ', apiResult);
      const result = apiResult.data;
      // console.log('FETCH_STATUS-RESULT: ', result);
      yield put({
        type: actions.FETCHING_STATUS,
      });
      if (result.success === true) {
        yield put({
          type: actions.STATUS_FETCHED,
          payload: result.data,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_STATUS_FAILED,
        payload: error,
      });
    }
  });
}

export function* saveAuthManagement() {
  yield takeEvery('SAVE_AUTH_ROLE_MANAGEMENT', function* (payload) {
    const data = payload.payload;
    try {
      yield put({
        type: actions.SAVING_AUTH_ROLE_MANAGEMENT,
      });
      const apiResult = yield saveAuthManagementReq(data.selectedId, data);
      const result = apiResult.data;
      if (result.success === true) {
        yield put({
          type: actions.AUTH_ROLE_MANAGEMENT_SAVED,
          payload: result.data,
        });
      } else {
        yield put({
          type: actions.SAVE_AUTH_ROLE_MANAGEMENT_FAILED,
          payload: result.data,
        });
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_AUTH_ROLE_MANAGEMENT_FAILED,
        payload: error,
      });
    }
  });
}

export function* resetMerchantUserPassword() {
  yield takeEvery('RESET_MERCHANT_USER_PASSWORD', function* (payload) {
    try {
      yield put({
        type: actions.RESETTING_MERCHANT_USER_PASSWORD,
      });

      const apiResult = yield resetMerchantUserPasswordRequest(payload.payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.MERCHANT_USER_PASSWORD_RESET_SUCCESS,
        });
      } else {
        yield put({
          type: actions.MERCHANT_USER_PASSWORD_RESET_FAILED,
        });
      }
    } catch (error) {
      yield put({
        type: actions.MERCHANT_USER_PASSWORD_RESET_ERROR,
      });
    }
  });
}

// FOR USER MANAGEMENT
export function* fetchMerchantsSettings() {
  yield takeEvery('FETCH_MERCHANT_LIST_SETTINGS', function* (action) {
    const state = yield select();
    const identity = state.Auth.identity;
    const requestPayload = action.payload ? { ...action.payload } : {};
    const append = requestPayload.append === true;
    delete requestPayload.append;

    try {
      yield put({
        type: actions.FETCHING_MERCHANT_LIST_SETTINGS,
        append,
      });
      const apiResult = yield fetchMerchantsReq(identity, requestPayload);
      const result = apiResult.data;
      if (result.success === true) {
        const hasMore = requestPayload.pageSize && result.data && result.data.result
          ? result.data.result.length === requestPayload.pageSize
          : true;

        yield put({
          type: actions.FETCHED_MERCHANT_LIST_SETTINGS,
          payload: result.data,
          append,
          hasMore,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_LIST_SETTINGS_FAILED,
        payload: error,
      });
    }
  });
}

export function* fetchUsers() {
  yield takeEvery('FETCH_USERS', function* (action) {
    const payload = action.payload;
    const append = payload && payload.append === true;
    const requestPayload = typeof payload === 'object' && payload !== null ? { ...payload } : payload;
    if (typeof requestPayload === 'object' && requestPayload !== null) {
      delete requestPayload.append;
    }

    try {
      yield put({
        type: actions.FETCHING_USERS,
        append,
      });
      const apiResult = yield fetchUsersReq(requestPayload);
      console.log('FETCH_USERS RESULT', apiResult.data.data)
      if (apiResult.data.success) {
        const hasMore = requestPayload && requestPayload.pageSize && Array.isArray(apiResult.data.data)
          ? apiResult.data.data.length === requestPayload.pageSize
          : true;

        yield put({
          type: actions.FETCHED_USERS,
          data: apiResult.data.data,
          append,
          hasMore,
        });
      } else {
        yield put({
          type: actions.FETCH_USERS_FAILED,
          message: apiResult.data.message
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USERS_FAILED,
        message: 'Failed to load users.'
      });
    }
  });
}

export function* fetchTenants() {
  yield takeEvery('FETCH_TENANT', function* (action) {
    const payload = action.payload;
    const append = payload && payload.append === true;
    const requestPayload = typeof payload === 'object' && payload !== null ? { ...payload } : payload;
    if (typeof requestPayload === 'object' && requestPayload !== null) {
      delete requestPayload.append;
    }

    try {
      yield put({
        type: actions.FETCHING_TENANT,
        append,
      });
      const apiResult = yield fetchUsersReq(requestPayload);
      console.log('FETCH_TENANT RESULT', apiResult.data.data)
      if (apiResult.data.success) {
        const hasMore = requestPayload && requestPayload.pageSize && Array.isArray(apiResult.data.data)
          ? apiResult.data.data.length === requestPayload.pageSize
          : true;

        yield put({
          type: actions.FETCHED_TENANT,
          data: apiResult.data.data,
          append,
          hasMore,
        });
      } else {
        yield put({
          type: actions.FETCH_TENANT_FAILED,
          message: apiResult.data.message
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TENANT_FAILED,
        message: 'Failed to load users.'
      });
    }
  });
}

export function* searchMerchant() {
  yield takeEvery('SETTINGS_SEARCH_MERCHANTS', function* (payload) {
    const state = yield select();
    const identity = state.Auth.identity;
    try {
      yield put({
        type: actions.SETTINGS_SEARCHING_MERCHANTS,
      });
      const apiResult = yield merchantSearch(payload.payload, identity);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SETTINGS_SEARCHED_MERCHANTS,
          payload: result.data,
        });
      }
    } catch (error) {
      yield put({
        type: actions.SETTINGS_SEARCHING_MERCHANTS_FAILED,
        payload: error,
      });
    }
  });
}

export function* addUser() {
  yield takeEvery('ADD_USER', function* (payload) {
    try {
      yield put({
        type: actions.ADDING_USER,
      });
      const apiResult = yield addUserAccount(payload.payload);
      console.log('ADD_USER RESULT', apiResult.data.data)
      if (apiResult.data.success === true) {
        yield put({
          type: actions.ADDED_USER,
          data: apiResult.data.data,
        });
      } else {
        yield put({
          type: actions.ADD_USER_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_USER_FAILED,
        messsage: 'Failed to add user.',
      });
    }
  });
}

export function* addTenant() {
  yield takeEvery('ADD_TENANT', function* (payload) {
    try {
      yield put({
        type: actions.ADDING_TENANT,
      });
      const apiResult = yield addTenantAccount(payload.payload);
      console.log('ADD_TENANT RESULT', apiResult.data)
      if (apiResult.data.success === true) {
        yield put({
          type: actions.ADDED_TENANT,
          data: apiResult.data.data,
        });
      } else {
        yield put({
          type: actions.ADD_TENANT_FAILED,
          message: apiResult.data.message ? apiResult.data.message : apiResult.data.data.response_advise.includes('username already exists in the system') ? 'User already exist' : apiResult.data.data.response_message.replace('.', '')
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_TENANT_FAILED,
        messsage: 'Failed to add user.',
      });
    }
  });
}

export function* editUser() {
  yield takeEvery('EDIT_USER', function* (payload) {
    try {
      yield put({
        type: actions.EDITING_USER,
      });
      // console.log('EDIT DATA', payload.payload);
      const apiResult = yield editUserAccount(payload.payload);
      console.log('CHECK EDIT USER ACCOUNT RESULT', apiResult);
      if (apiResult.data.success === true) {
        // console.log('CHECKING PAYLOAD OF EDIT',payload.payload)
        yield put({
          type: actions.EDITED_USER,
          message: apiResult.data.message,
          // user: payload.payload,
          user: apiResult.data.data.data
        });
      } else {
        yield put({
          type: actions.EDIT_USER_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_USER_FAILED,
        messsage: 'Failed to edit user.',
      });
    }
  });
}
export function* deleteUser() {
  yield takeEvery('DELETE_USER', function* (payload) {
    const state = yield select();
    const fetchedUsers = state.Settings.fetchedUsers;
    try {
      yield put({
        type: actions.DELETING_USER,
      });
      const apiResult = yield deleteUserAccount(payload.payload);
      if (apiResult.data.success === true) {
        console.log('CHECK PAYLOAD', payload);
        console.log('CHECK FETCHED USERS', fetchedUsers);
        const updatedUsers = _.reject(fetchedUsers, { id: payload.payload.id });
        console.log('CHECK UPDATED USERS', updatedUsers);
        yield put({
          type: actions.DELETED_USER,
          message: apiResult.data.message,
          users: updatedUsers,
        });
      } else {
        yield put({
          type: actions.DELETE_USER_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_USER_FAILED,
        message: 'Failed to delete user.',
      });
    }
  });
}

export function* rotatingCreds() {
  yield takeEvery('ROTATE_CREDENTIALS', function* (payload) {
    try {
      yield put({
        type: actions.ROTATING_CREDENTIALS,
      });
      console.log('CHECKING PAYLOAD OF ROTATE CREDENTIALS', payload.payload)
      const apiResult = yield rotateCredsReq(payload.payload);
      console.log('CHECK ROTATE CREDENTIALS RESULT', apiResult);
      if (apiResult.data.success === true) {
        console.log('ROTATED CREDENTIALS SUCCESS', apiResult.data.success);
        yield put({
          type: actions.ROTATED_CREDENTIALS,
          // message: apiResult.data.message,
          user: apiResult.data.data.data
        });
      } else {
        yield put({
          type: actions.ROTATE_CREDENTIALS_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ROTATE_CREDENTIALS_FAILED,
        messsage: 'Failed to rotate credentials.',
      });
    }
  });
}

export function* generatingSecretKeyIv() {
  yield takeEvery('GENERATE_SECRET_KEY_IV', function* (payload) {
    try{
      yield put({
        type: actions.GENERATING_SECRET_KEY_IV
      })
      console.log('CHECKING PAYLOAD OF GENERATE SECRET KEY AND IV', payload.payload)
      const apiResult = yield generateSecretKeyIvRequest(payload.payload);
      console.log('CHECK GENERATE SECRET KEY AND IV RESULT', apiResult);
      if (apiResult.data.success === true) {
        console.log('GENERATE SECRET KEY AND IV SUCCESS', apiResult.data.success);
        yield put({
          type: actions.GENERATED_SECRET_KEY_IV,
          payload: {
            tenant_link: payload.payload.id
          }
        });
      } else {
        yield put({
          type: actions.GENERATE_SECRET_KEY_IV_FAILED,
          message: apiResult.data.message,
          payload: {
            tenant_link: payload.payload.id
          }
        });
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SECRET_KEY_IV_FAILED,
        message: 'Failed to generate secret key and IV.'
      });
    }
  });
}

export function* fetchingAllWalletGroups() {
  yield takeEvery('FETCH_ALL_WALLET_GROUPS', function*(payload) {
    try {
      yield put({
        type: actions.FETCHING_ALL_WALLET_GROUPS
      });

      const apiResult = yield fetchAllWalletGroups(payload.payload);
      console.log('CHECK FETCH ALL WALLET GROUPS RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.FETCHED_ALL_WALLET_GROUPS,
          payload: apiResult.data.data,
          message: 'Fetched all wallet groups successfully'
        })
      } 
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_WALLET_GROUPS_FAILED,
        payload: error,
        message: 'Fetch all wallet groups failed',
      });
    }
  });
}

export function* fetchingWalletGroupGroups() {
  yield takeEvery(actions.FETCH_WALLET_GROUP_GROUPS, function*(payload) {
    try {
      yield put({
        type: actions.FETCHING_WALLET_GROUP_GROUPS
      });

      const apiResult = yield fetchWalletGroupGroups(payload.payload);
      console.log('CHECK FETCH WALLET GROUP GROUPS RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.FETCHED_WALLET_GROUP_GROUPS,
          payload: apiResult.data.data,
          message: 'Fetched Wallet Group Groups successfully'
        })
      } 
    } catch (error) {
      yield put({
        type: actions.FETCH_WALLET_GROUP_GROUPS_FAILED,
        payload: error,
        message: 'Fetch Wallet Group Groups failed',
      });
    }
  });
}

export function* addingWalletGroup() {
  yield takeEvery(actions.ADD_WALLET_GROUP, function*(payload) {
    try {
      yield put({
        type: actions.ADDING_WALLET_GROUP
      });

      const apiResult = yield addWalletGroup(payload.payload);
      console.log('CHECK ADD WALLET GROUP RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.ADDED_WALLET_GROUP,
          payload: apiResult.data.data,
          message: 'Wallet group added successfully'
        })
      } else {
        yield put({
          type: actions.ADD_WALLET_GROUP_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_WALLET_GROUP_FAILED,
        payload: error,
        message: 'Add wallet group failed',
      });
    }
  });
}

export function* editingWalletGroup() {
  yield takeEvery(actions.EDIT_WALLET_GROUP, function*(payload) {
    try {
      yield put({
        type: actions.EDITING_WALLET_GROUP
      });

      const apiResult = yield editWalletGroup(payload.payload);
      console.log('CHECK EDIT WALLET GROUP RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.EDITED_WALLET_GROUP,
          payload: apiResult.data.data,
          message: 'Wallet group edited successfully'
        })
      } else {
        yield put({
          type: actions.EDIT_WALLET_GROUP_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_WALLET_GROUP_FAILED,
        payload: error,
        message: 'Edit wallet group failed',
      });
    }
  });
}

export function* deletingWalletGroup() {
  yield takeEvery(actions.DELETE_WALLET_GROUP, function*(payload) {
    try {
      yield put({
        type: actions.DELETING_WALLET_GROUP
      });

      const apiResult = yield deleteWalletGroup(payload.id);
      console.log('CHECK DELETE WALLET GROUP RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.DELETED_WALLET_GROUP,
          payload: apiResult.data.data,
          message: 'Wallet group deleted'
        })
      } else {
        yield put({
          type: actions.DELETE_WALLET_GROUP_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_WALLET_GROUP_FAILED,
        payload: error,
        message: 'Delete wallet group failed',
      });
    }
  });
}

export function* activatingWalletGroup() {
  yield takeEvery(actions.ACTIVATE_WALLET_GROUP, function*(payload) {
    try {
      yield put({
        type: actions.ACTIVATING_WALLET_GROUP
      });

      const apiResult = yield activateWalletGroup(payload.id);
      console.log('CHECK ACTIVATE WALLET GROUP RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.ACTIVATED_WALLET_GROUP,
          payload: apiResult.data.data,
          message: 'Wallet group activated'
        })
      } else {
        yield put({
          type: actions.ACTIVATE_WALLET_GROUP_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ACTIVATE_WALLET_GROUP_FAILED,
        payload: error,
        message: 'Activate wallet group failed',
      });
    }
  });
}

export function* deactivatingWalletGroup() {
  yield takeEvery(actions.DEACTIVATE_WALLET_GROUP, function*(payload) {
    try {
      yield put({
        type: actions.DEACTIVATING_WALLET_GROUP
      });

      const apiResult = yield deactivateWalletGroup(payload.id);
      console.log('CHECK DEACTIVATE WALLET GROUP RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.DEACTIVATED_WALLET_GROUP,
          payload: apiResult.data.data,
          message: 'Wallet group deactivated'
        })
      } else {
        yield put({
          type: actions.DEACTIVATE_WALLET_GROUP_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DEACTIVATE_WALLET_GROUP_FAILED,
        payload: error,
        message: 'Deactivate wallet group failed',
      });
    }
  });
}

export function* fetchingAllBankAccounts() {
  yield takeEvery('FETCH_ALL_BANK_ACCOUNTS', function*(payload) {
    try {
      yield put({
        type: actions.FETCHING_ALL_BANK_ACCOUNTS
      });

      const apiResult = yield fetchAllBankAccounts(payload.payload);
      console.log('CHECK FETCH ALL BANK ACCOUNTS RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.FETCHED_ALL_BANK_ACCOUNTS,
          payload: apiResult.data.data,
          message: 'Fetched all bank accounts successfully'
        })
      } 
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_BANK_ACCOUNTS_FAILED,
        payload: error,
        message: 'Fetch all bank accounts failed',
      });
    }
  });
}

export function* fetchingBankLookups() {
  yield takeEvery('FETCH_BANK_LOOKUPS', function*(payload) {
    try {
      yield put({
        type: actions.FETCHING_BANK_LOOKUPS
      });

      const apiResult = yield fetchBankLookups(payload.payload);
      console.log('CHECK FETCH BANK LOOKUPS RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.FETCHED_BANK_LOOKUPS,
          payload: apiResult.data.data,
          message: 'Fetched bank lookups successfully'
        })
      } 
    } catch (error) {
      yield put({
        type: actions.FETCH_BANK_LOOKUPS_FAILED,
        payload: error,
        message: 'Fetch bank lookups failed',
      });
    }
  });
}

export function* addingBankAccount() {
  yield takeEvery(actions.ADD_BANK_ACCOUNT, function*(payload) {
    try {
      yield put({
        type: actions.ADDING_BANK_ACCOUNT
      });

      console.log('CHECK PAYLOAD FOR ADDING BANK ACCOUNT', payload.payload)
      const apiResult = yield addBankAccount(payload.payload);
      console.log('CHECK ADD BANK ACCOUNT RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.ADDED_BANK_ACCOUNT,
          payload: apiResult.data.data,
          message: 'Added bank account successfully'
        });
      } else {
        yield put({
          type: actions.ADD_BANK_ACCOUNT_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_BANK_ACCOUNT_FAILED,
        payload: error,
        message: 'Add bank account failed',
      });
    }
  });
}

export function* editingBankAccount() {
  yield takeEvery(actions.EDIT_BANK_ACCOUNT, function*(payload) {
    try {
      yield put({
        type: actions.EDITING_BANK_ACCOUNT
      });

      const apiResult = yield editBankAccount(payload.payload);
      console.log('CHECK EDIT BANK ACCOUNT RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.EDITED_BANK_ACCOUNT,
          payload: apiResult.data.data,
          message: 'Edited bank account successfully'
        });
      } else {
        yield put({
          type: actions.EDIT_BANK_ACCOUNT_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_BANK_ACCOUNT_FAILED,
        payload: error,
        message: 'Edit bank account failed',
      });
    }
  });
}

export function* deletingBankAccount() {
  yield takeEvery('DELETE_BANK_ACCOUNT', function*(payload) {
    try {
      yield put({
        type: actions.DELETING_BANK_ACCOUNT
      });

      const apiResult = yield deleteBankAccount(payload.id);
      console.log('CHECK DELETE BANK ACCOUNT RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.DELETED_BANK_ACCOUNT,
          payload: apiResult.data.data,
          message: 'Deleted bank account successfully'
        })
      } else {
        yield put({
          type: actions.DELETE_BANK_ACCOUNT_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_BANK_ACCOUNT_FAILED,
        payload: error,
        message: 'Delete bank account failed',
      });
    }
  });
}

export function* activatingBankAccount() {
  yield takeEvery(actions.ACTIVATE_BANK_ACCOUNT, function*(payload) {
    try {
      yield put({
        type: actions.ACTIVATING_BANK_ACCOUNT
      });

      const apiResult = yield activateBankAccount(payload.id);
      console.log('CHECK ACTIVATE BANK ACCOUNT RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.ACTIVATED_BANK_ACCOUNT,
          payload: apiResult.data.data,
          message: 'Activated bank account successfully'
        })
      } else {
        yield put({
          type: actions.ACTIVATE_BANK_ACCOUNT_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.ACTIVATE_BANK_ACCOUNT_FAILED,
        payload: error,
        message: 'Activate bank account failed',
      });
    }
  });
}

export function* deactivatingBankAccount() {
  yield takeEvery('DEACTIVATE_BANK_ACCOUNT', function*(payload) {
    try {
      yield put({
        type: actions.DEACTIVATING_BANK_ACCOUNT
      });

      const apiResult = yield deactivateBankAccount(payload.id);
      console.log('CHECK DEACTIVATE BANK ACCOUNT RESULT', apiResult);

      if (apiResult.data.success === true) {
        yield put({
          type: actions.DEACTIVATED_BANK_ACCOUNT,
          payload: apiResult.data.data,
          message: 'Deactivated bank account successfully'
        })
      } else {
        yield put({
          type: actions.DEACTIVATE_BANK_ACCOUNT_FAILED,
          message: apiResult.data.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.DEACTIVATE_BANK_ACCOUNT_FAILED,
        payload: error,
        message: 'Deactivate bank account failed',
      });
    }
  });
}

// function samplePostCall(data) {
//     return post(`<change to api path>`, data);
// }

// function sampleGetCall() {
//     return get(`<change to api path>`);
// }

// function samplePutCall(data) {
//     return PUT(`<change to api path>`, data);
// }

function searchAudit(data) {
  return postWithToken(`auditlogs/search/logs`, data);
}
function getRoles() {
  return get('user_management/roles/fetch_all_roles/ui');
}

function addAuthRoleReq(data) {
  return post(`roles/save_role/ui`, data);
}
function fetchCoreModuleRequest() {
  // return get(`core-modules/system/modules/new/${id}`);
  return get(`role_management/core_modules/system/modules/new`);
}
function fetchRolePermissionRequest(id) { // here
  return get(`role_management/roles/role_authorization/${id}`);
}
function fetchStatusRequest() {
  // add endpoint for auth management save
  return get(`lookups/fetch/status/`);
}
function saveAuthManagementReq(id, data) {
  // console.log('SAVE_AUTH_DATA', data);
  // return get(`core-modules/system/modules/new/${id}`);
  // return post(`roles/${id}/authorization/update_roles_auth`, data, { page: 1, limit: 50 });
  return PUT(`roles/edit_role/${id}`, data);
}
function fetchLookupsReq() {
  return get(`lookups/fetch/all`);
}
function fetchUserManagementLookupsReq() {
  return get(`user_management/lookups/fetch/all`);
}
function fetchResponseCodeLookupsReq() {
  return get(`responsecodes/lookups/fetch/all`);
}
function fetchStatusLookupsData(data) {
  return get(`lookups/`, data, null, data.group, null, null);
}

function addLookupsReq(data) {
  return post(`lookups/new/`, data);
}

function updateLookupsReq(data) {
  return PUT(`lookups/new/${data.id}`, data);
}

function fetchResponseCodeReq(data) {
  const newData = {
    page: data.page,
    mid: data.mid,
  }
  return get(`responsecodes/get/new`, newData, newData.page, null, null);
}

function addResponseCodeReq(data) {
  return post(`responsecodes/new`, data);
}

function updateResponseCodeReq(data) {
  return PUT(`responsecodes/new/${data.Id}`, data);
}

function deleteResponseCodeReq(data) {
  return post(`responsecodes/delete`, data);
}
function fetchMerchantsReq(identity, data = {}) {
  const requestData = {
    role: identity?.role?.role?.label,
    tenantId: identity?.tenantId,
    tenantLink: identity?.tenantLink,
    ...(data.currentPage !== undefined ? { currentPage: data.currentPage } : {}),
    ...(data.pageSize !== undefined ? { pageSize: data.pageSize } : {}),
  };
  return postWithToken(`authenticate/fetch_merchants`, requestData);
}
function fetchUsersReq(payload) {
  if (typeof payload === 'string' || typeof payload === 'number') {
    return get(`user_management/authenticate/fetch_by_id/${payload}`);
  }

  const id = payload && payload.id ? payload.id : '';
  const requestData = {};

  if (payload && payload.currentPage !== undefined) {
    requestData.currentPage = payload.currentPage;
  }
  if (payload && payload.pageSize !== undefined) {
    requestData.pageSize = payload.pageSize;
  }

  return get(`user_management/authenticate/fetch_by_id/${id}`, requestData);
}
function merchantSearch(data, identity) {
  data = {
    ...data,
    tenantId: identity.tenantId,
    tenantLink: identity.tenantLink,
  };
  return post(`company/search`, data);
}
function addUserAccount(data) {
  return post(`authenticate/add_user/ui`, data);
}
function addTenantAccount(data) {
  return post(`tenants/add`, data);
}
function editUserAccount(data) {
  const dataBody = {
    data1: data.data1,
    data2: data.data2,
    data3: data.data3,
    key: data.key
  };
  return PUT(`authenticate/new/${data.id}`, dataBody);
}
function deleteUserAccount(data) {
  return PUT(`authenticate/delete/${data.id}`, data);
}
function resetMerchantUserPasswordRequest(id) {
  const data = injectRequestorInformation()
  return PUT(`authenticate/reset_password/ui/${id}`, data);
}

function downloadAuditLogsRequest(payload) {
  return post(`auditlogs/download_logs`, payload);
}

function fetchDownloadListApi(data) {
  return postWithToken(`auditlogs/transactions/fetch_download_list`, data);
}

function getDownloadReportApi(id) {
  return get(`auditlogs/transactions/get_downloaded_report/${id}`);
}

function rotateCredsReq(data) {
  return post(`user_management/rotate_credentials`, data);
}

function generateSecretKeyIvRequest(payload) {
  return PUT(`user_management/generate_secret_key_iv`, payload);
}

function fetchAllWalletGroups() {
  return get(`wallet_group/all`);
}

function fetchWalletGroupGroups() {
  return get(`wallet_group/groups/all`);
}

function addWalletGroup(payload) {
  return post(`wallet_group/add`, payload);
}

function editWalletGroup(payload) {
  return PUT(`wallet_group/edit/${payload.id}`, payload)
}

function deleteWalletGroup(id) {
  return PUT(`wallet_group/delete/${id}`)
}

function activateWalletGroup(id) {
  return PUT(`wallet_group/activate/${id}`)
}

function deactivateWalletGroup(id) {
  return PUT(`wallet_group/deactivate/${id}`)
}

function fetchAllBankAccounts() {
  return get(`bank_account/all`);
}

function fetchBankLookups() {
  return get(`bank_account/bank/lookups/all`);
}

function addBankAccount(payload) {
  return post(`bank_account/add`, payload);
}

function editBankAccount(payload) {
  return PUT(`bank_account/edit/${payload.bankAccountId}`, payload);
}

function deleteBankAccount(id) {
  return PUT(`bank_account/delete/${id}`);
}

function activateBankAccount(id) {
  return PUT(`bank_account/activate/${id}`);
}

function deactivateBankAccount(id) {
  return PUT(`bank_account/deactivate/${id}`);
}

export default function* rootSaga() {
  yield all([
    fork(getSampleList),
    fork(searchAuditLogs),
    fork(getRolesList),
    fork(addAuthRole),
    fork(fetchPermission),
    fork(fetchStatus),
    fork(saveAuthManagement),
    fork(fetchLookups),
    fork(fetchUserManagementLookups),
    fork(fetchResponseCodeLookups),
    fork(fetchLookupsStatus),
    fork(addLookups),
    fork(updateLookups),
    // fork(searchAuditLogs),
    fork(fetchResponseCode),
    fork(addResponseCode),
    fork(updateResponseCode),
    fork(deleteResponseCode),
    fork(fetchMerchantsSettings),
    fork(fetchUsers),
    fork(searchMerchant),
    fork(addUser),
    fork(addTenant),
    fork(editUser),
    fork(deleteUser),
    fork(resetMerchantUserPassword),
    fork(fetchTenants),
    fork(downloadAuditLogs),
    fork(getLogsDownloadList),
    fork(fetchDownloadReport),
    fork(rotatingCreds),
    fork(generatingSecretKeyIv),
    fork(fetchingAllWalletGroups),
    fork(fetchingWalletGroupGroups),
    fork(addingWalletGroup),
    fork(editingWalletGroup),
    fork(deletingWalletGroup),
    fork(activatingWalletGroup),
    fork(deactivatingWalletGroup),
    fork(fetchingAllBankAccounts),
    fork(fetchingBankLookups),
    fork(addingBankAccount),
    fork(editingBankAccount),
    fork(deletingBankAccount),
    fork(activatingBankAccount),
    fork(deactivatingBankAccount),
  ]);
}